var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkIconHexagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0L19.5 5.25V15.75L10 21L0.5 15.75V5.25L10 0Z",
    fill: "#FF6633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.61628L1.96154 6.05859V14.9414L10 19.3837L18.0385 14.9414V6.05859L10 1.61628ZM19.5 5.25L10 0L0.5 5.25V15.75L10 21L19.5 15.75V5.25Z",
    fill: "#36434E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4922 5.24606L9.99932 0L9.99219 0.00394326V20.9961L9.99932 21L19.4922 15.7539V5.24606Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1404 6.20073C15.5569 6.51363 15.621 7.08037 15.2835 7.46658L8.99269 14.6666C8.8186 14.8658 8.5611 14.9867 8.28486 14.999C8.00862 15.0112 7.73987 14.9136 7.54609 14.7306L4.77812 12.1173C4.40252 11.7627 4.40805 11.1929 4.79049 10.8446C5.17293 10.4963 5.78744 10.5014 6.16305 10.856L8.169 12.7499L13.7752 6.33347C14.1127 5.94726 14.7239 5.88783 15.1404 6.20073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIconHexagonal);
export default __webpack_public_path__ + "static/media/check-mark-icon-hexagonal.381b37bbf3cfdc0b80bc6462664084ca.svg";
export { ForwardRef as ReactComponent };